// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__vhvrG","select":"Header_select__1FcDE","clinic":"Header_clinic__2-2_b"};